export default __webpack_public_path__ + "static/media/white_datalayer.a877b3fe.png";